import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PendingVerifications.css";

const API_ROOT     = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const DOC_BASE_URL = "https://pumis.puchd.ac.in/";

export default function DrPendingPrincipals() {
  const navigate = useNavigate();

  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);

  const [teachers, setTeachers]     = useState([]);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState("");
  const [actionMsg, setActionMsg]   = useState({ type: "", text: "" });
  const [processing, setProcessing] = useState(new Set());

  const fetchPending = async () => {
    setLoading(true);
    setError("");
    setActionMsg({ type: "", text: "" });
    try {
      const res  = await fetch(`${API_ROOT}/api/college-teachers/pending-verifications?moduleId=${moduleId}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load pending verifications");
      setTeachers(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      setError(err.message || "Failed to load pending verifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moduleId !== 26) {
      navigate("/");
      return;
    }
    fetchPending();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  const handleAction = async (teacherId, status, mobile, selectEl) => {
    const label = status === "Y" ? "Approve" : "Reject";
    if (!window.confirm(`${label} principal registration?`)) {
      selectEl.value = "";
      return;
    }

    setProcessing(prev => new Set(prev).add(teacherId));
    setActionMsg({ type: "", text: "" });

    try {
      const res = await fetch(`${API_ROOT}/api/college-teachers/pending-verifications/update-status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ moduleId, teacherId, status, mobile })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to update status");

      setActionMsg({ type: "success", text: data.message || "Status updated." });
      setTeachers(prev => prev.filter(t => t.TeacherID !== teacherId));
    } catch (err) {
      setActionMsg({ type: "error", text: err.message || "Failed to update status." });
      setProcessing(prev => {
        const next = new Set(prev);
        next.delete(teacherId);
        return next;
      });
      selectEl.value = "";
    }
  };

  if (moduleId !== 26) return null;

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Pending Verification of Principals</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      {actionMsg.text && (
        <div className={`alert alert-${actionMsg.type === "success" ? "success" : "danger"}`}>
          {actionMsg.text}
        </div>
      )}

      {loading ? (
        <div className="text-muted">Loading...</div>
      ) : !error && teachers.length === 0 ? (
        <div className="alert alert-info">No pending principal verifications found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle pending-verif-table">
            <thead style={{ "--bs-table-bg": "#008080", color: "white" }}>
              <tr>
                <th>SNo</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Mobile</th>
                <th>City</th>
                <th>State</th>
                <th>Doc</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((t, idx) => (
                <tr key={t.TeacherID}>
                  <td>{idx + 1}</td>
                  <td>{t.TName}</td>
                  <td>{t.Designation}</td>
                  <td>{t.Mobile}</td>
                  <td>{t.City}</td>
                  <td>{t.State}</td>
                  <td>
                    {t.SupportingDoc ? (
                      <button
                        className="btn btn-sm btn-outline-info"
                        onClick={() => window.open(DOC_BASE_URL + t.SupportingDoc, "_blank")}
                      >
                        View
                      </button>
                    ) : (
                      <span style={{ color: "red" }}>NoDoc</span>
                    )}
                  </td>
                  <td>
                    <select
                      className="form-select form-select-sm"
                      defaultValue=""
                      disabled={processing.has(t.TeacherID)}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!val) return;
                        handleAction(t.TeacherID, val, t.Mobile, e.target);
                      }}
                    >
                      <option value="" disabled>Status</option>
                      <option value="Y">Approved</option>
                      <option value="R">Rejected</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
